@if (content) {
<div class="flex-column flex-justify-center flex-middle pos-relative _container">
    <simple-step [content]="ponyStepData"
                 [(selection)]="storageData.pony"
                 (selectionChange)="updateStorage()"
                 [squareVariant]="true"></simple-step>
    <!-- button -->
    <button *ifSize="'XL'"
            class="m-t-8 m-b button"
            [disabled]="!isDataValid()"
            (click)="next()">{{'Confirm & Continue' | translate}}</button>
</div>
<div *ifSize="'SM'"
     class="pos-fixed bottom-0 z-2 bg-col-w w-12 p-a box-shadow-1">
    <button class="w-12 button"
            [disabled]="!isDataValid()"
            (click)="next()">{{'Confirm & Continue' | translate}}</button>
</div>
}